import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'salarySteps';
export const salaryStepsActions = makeActions(MODEL_NAME,'id','salary-steps');

export const getAllSalarySteps = salaryStepsActions.getAll;
export const editSalarySteps = salaryStepsActions.edit;
export const createSalarySteps = salaryStepsActions.create;
export const getByIdSalarySteps = salaryStepsActions.getDataById;
